import { render } from "./financialProduct.vue?vue&type=template&id=3da083f4&scoped=true"
import script from "./financialProduct.vue?vue&type=script&lang=js"
export * from "./financialProduct.vue?vue&type=script&lang=js"

import "./financialProduct.vue?vue&type=style&index=0&id=3da083f4&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da083f4"]])

export default __exports__